import { ocultarDietaRecebida, getDietasAtivas, getDietasCompartilhadas, calcularDieta, processaResultadoDieta, saveDieta, saveDietaOculta, removeDieta, relatorioFinanceiroCenariosGMD, relatorioFinanceiroCenarios, relatorioFinanceiro, loadDietaInDietaRefinada } from './dietas/actions'
import { calculaPredicao, savePredicao, savePredicaoOculta, removePredicao, getDefaultPredicao } from './predicoes/actions'
import { recalculaNutrientes } from './nutrientes/actions'
import { calculaExigencias } from './exigencias/actions'
import { getAditivos, getAlimentos, getAlimentosBasicosCqbal, getAlimentosEmpresa, getAlimentosUsuario, getTipos, relatorioTabelaResumida } from './alimentos/actions'
import { getAcessoModulo } from './auth/actions'
import { getClientes, setClienteSelecionado } from './consultoria/actions'
import { getNotificacoes, setDietaLida } from './notificacoes/actions'
import { getCupons, ativarCupom } from './cupons/actions'

export default {
  ocultarDietaRecebida,
  setDietaLida,
  getNotificacoes,
  setClienteSelecionado,
  getClientes,
  getAcessoModulo,
  getTipos,
  getDietasAtivas,
  getDefaultPredicao,
  getDietasCompartilhadas,
  calcularDieta,
  relatorioFinanceiroCenariosGMD,
  relatorioFinanceiroCenarios,
  relatorioFinanceiro,
  calculaExigencias,
  calculaPredicao,
  processaResultadoDieta,
  recalculaNutrientes,
  savePredicao,
  savePredicaoOculta,
  saveDieta,
  saveDietaOculta,
  removeDieta,
  removePredicao,
  getAditivos,
  getCupons,
  ativarCupom,
  relatorioTabelaResumida,
  getAlimentosBasicosCqbal,
  getAlimentos,
  getAlimentosEmpresa,
  getAlimentosUsuario,
  loadDietaInDietaRefinada
}
